export enum AffiliateApplicationStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export interface AffiliateApplication {
  id: string;
  user_id: string;
  application_data: Record<string, any>;
  affiliate_type: string;
  status: AffiliateApplicationStatus;
  reject_reasons: string;
}

export interface CreateAffilicateApplicationPayload {
  email: string;
  application_data: Record<string, any>;
}
